import { Controller, useFormContext } from 'react-hook-form';
import TextField from 'src/components/TextField';

import { ServiceNotServicedFormData } from '../RelatedService.schema';

export const ServiceNotServicedForm = () => {
  const { control } = useFormContext<ServiceNotServicedFormData>();

  return (
    <div className="mt-4 flex flex-col gap-6 border-t border-neutral-800 bg-secondary-900 pt-4">
      <Controller
        name="reason"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <div className="flex flex-col gap-1">
            <p className="text-neutral-400 typography-body-sm">Reason</p>
            <TextField
              placeholder="Explain why services are not being provided."
              error={error?.message}
              {...field}
            />
          </div>
        )}
      />
    </div>
  );
};
